import { List, ListItem, Stack, SxProps, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

interface ILanguages {
  languagesList: string[];
}

export const Languages = ({ languagesList }: ILanguages) => {
  const isDesktop = useIsDesktop();

  const listItemSx: SxProps = {
    p: '0 0 0 8px',
    '&::before': {
      content: '"\\2022"',
      fontSize: '20px',
      marginRight: '8px',
    },
  };

  return (
    <Stack gap='8px'>
      <Typography variant={isDesktop ? 'body2' : 'body1'}>
        {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.languages}
      </Typography>
      <List sx={{ listStyleType: 'disc', listStylePosition: 'inside', p: 0 }}>
        {languagesList.map((language: string, index: number) => {
          return (
            <ListItem key={index} sx={{ ...listItemSx }}>
              <Typography variant='body3'>{language}</Typography>
            </ListItem>
          );
        })}
      </List>
    </Stack>
  );
};
